var render = function render(_c, _vm) {
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12 col-sm-12" }, [
      _c("div", { staticClass: "row", class: _vm.props.customClass }, [
        _c(
          "div",
          {
            staticClass: "row col-sm-12",
            class: {
              "col-md-8": _vm.props.showVisitDetails,
              "col-md-12": !_vm.props.showVisitDetails
            }
          },
          [
            _vm.props.value.requestNumber
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-12",
                    class: {
                      "col-md-3": _vm.props.showVisitDetails,
                      "col-md-2": !_vm.props.showVisitDetails
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font-14 font-weight-normal color-secondary-6"
                      },
                      [_vm._v(" Número de Solicitud: ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "font-16 font-weight-normal color-black" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(_vm.props.value.requestNumber)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.props.showStartDate,
                    expression: "props.showStartDate"
                  }
                ],
                staticClass: "col-sm-12",
                class: {
                  "col-md-3": _vm.props.showVisitDetails,
                  "col-md-2": !_vm.props.showVisitDetails
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-14 font-weight-normal color-secondary-6"
                  },
                  [_vm._v(" Fecha de Comienzo: ")]
                ),
                _c(
                  "p",
                  { staticClass: "font-16 font-weight-normal color-black" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.props.value.assignmentStartDate ||
                            _vm.props.assignmentStartDate ||
                            "-"
                        ) +
                        " "
                    )
                  ]
                )
              ]
            ),
            _vm.props.value.serviceTypeName
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-12",
                    class: {
                      "col-md-3": _vm.props.showVisitDetails,
                      "col-md-2": !_vm.props.showVisitDetails
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font-14 font-weight-normal color-secondary-6"
                      },
                      [_vm._v(" Tipo de Servicio: ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "font-16 font-weight-normal color-black" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(_vm.props.value.serviceTypeName)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.props.value.alternativeName
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-12",
                    class: {
                      "col-md-3": _vm.props.showVisitDetails,
                      "col-md-2": !_vm.props.showVisitDetails
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font-14 font-weight-normal color-secondary-6"
                      },
                      [_vm._v(" Nombre de Alternativa: ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "font-16 font-weight-normal color-black" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(_vm.props.value.alternativeName)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.props.value.numberOfStudents
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-12",
                    class: {
                      "col-md-3": _vm.props.showVisitDetails,
                      "col-md-2": !_vm.props.showVisitDetails
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font-14 font-weight-normal color-secondary-6"
                      },
                      [_vm._v(" Cantidad de Estudiantes: ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "font-16 font-weight-normal color-black" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(_vm.props.value.numberOfStudents)
                            ) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.props.value.grade
              ? _c(
                  "div",
                  {
                    staticClass: "col-sm-12",
                    class: {
                      "col-md-3": _vm.props.showVisitDetails,
                      "col-md-2": !_vm.props.showVisitDetails
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "font-14 font-weight-normal color-secondary-6"
                      },
                      [_vm._v(" Grado: ")]
                    ),
                    _c(
                      "p",
                      { staticClass: "font-16 font-weight-normal color-black" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("empty")(_vm.props.value.grade)) +
                            " "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "col-sm-12",
                class: {
                  "col-md-3": _vm.props.showVisitDetails,
                  "col-md-2": !_vm.props.showVisitDetails
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-14 font-weight-normal color-secondary-6"
                  },
                  [_vm._v(" Nombre de Asistente: ")]
                ),
                _c(
                  "p",
                  { staticClass: "font-16 font-weight-normal color-black" },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.props.value.assistanceName || "-") + " "
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.props.showAssignmentDates,
                    expression: "props.showAssignmentDates"
                  }
                ],
                staticClass: "col-md-3 col-sm-12"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "font-14 font-weight-normal color-secondary-6"
                  },
                  [_vm._v(" Vigencia: ")]
                ),
                _c(
                  "p",
                  { staticClass: "font-16 font-weight-normal color-black" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.props.value.assignmentStartDate ||
                            _vm.props.assignmentStartDate ||
                            "-"
                        ) +
                        " - " +
                        _vm._s(
                          _vm.props.value.assignmentEndDate ||
                            _vm.props.assignmentEndDate
                        ) +
                        " "
                    )
                  ]
                )
              ]
            )
          ]
        ),
        _vm.props.showVisitDetails
          ? _c(
              "div",
              {
                staticClass:
                  "col-md-3 col-sm-12 col-spacing d-flex align-items-start visit-day border-left pl-3 pl-md-3 pl-sm-3 mb-2 pt-0 ml-5"
              },
              [
                _c("div", { staticClass: "flex-grow-1 ml-1 ml-md-0 ml-sm-1" }, [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "color-gray-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Días Registrados en Visitas Regulares: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex row pl-3 pl-md-3 pl-sm-3" },
                      _vm._l(_vm.props.visitsRegular, function(visit, j) {
                        return _c(
                          "div",
                          {
                            key: `visit-regular-key-${j}`,
                            staticClass:
                              "bg-secondary-2 visit-day__box rounded col-1 mt-1 mr-1"
                          },
                          [
                            _c("span", { staticClass: "color-black font-14" }, [
                              _vm._v(" " + _vm._s(visit.visitDay) + " ")
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ]),
                  _c("div", { staticClass: "mt-3" }, [
                    _c(
                      "div",
                      {
                        staticClass: "color-gray-6 font-14 font-weight-normal"
                      },
                      [_vm._v(" Días Registrados en Ausencia: ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "d-flex row pl-md-3 pl-sm-3" },
                      _vm._l(_vm.props.visitsAbsence, function(visit, j) {
                        return _c(
                          "div",
                          {
                            key: `visit-regular-key-${j}`,
                            staticClass:
                              "bg-visit-absence visit-day__box rounded mr-2 col-1 mt-1"
                          },
                          [
                            _c("span", { staticClass: "color-black font-14" }, [
                              _vm._v(" " + _vm._s(visit.visitDay) + " ")
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ])
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }